import { render, staticRenderFns } from "./LabElementIndex.vue?vue&type=template&id=193e8f1a"
import script from "./LabElementIndex.vue?vue&type=script&lang=js"
export * from "./LabElementIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('193e8f1a')) {
      api.createRecord('193e8f1a', component.options)
    } else {
      api.reload('193e8f1a', component.options)
    }
    module.hot.accept("./LabElementIndex.vue?vue&type=template&id=193e8f1a", function () {
      api.rerender('193e8f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labElement/LabElementIndex.vue"
export default component.exports